import { getPlayerData } from "core-integration/src/store/player/reducers";
import { Button } from "plos/src/components/buttons/Button";
import { Login } from "plos/src/components/Login";
import { useLanguageFromPath } from "plos/src/hooks/useLanguageFromPath";
import { Trans, useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import { useSelector } from "react-redux";
import { useTrackingContext } from "../../contexts/TrackingContext";
import { getPlayerComp } from "../../utils/player-comps";
import {
  buttonContainerStyles,
  desktopOnlyHeading,
  imageStyles,
  loggedUserDiv,
  loggedUserText,
  textContainerStyles,
  textStyles,
} from "./loginPromo.css";
import styles from "./LoginPromo.module.css";

const LoginPromo = () => {
  const auth = useAuth();
  const { t } = useTranslation("home");
  const { fireClickTrackEvent } = useTrackingContext();
  const player = useSelector(getPlayerData);
  const language = useLanguageFromPath();

  const trackAuthClick = (
    action: "login" | "register",
    eventType: "login cta" | "register cta",
  ) => {
    fireClickTrackEvent(
      {
        event_category: action,
        event_component: "button clicks",
        event_detail: "page / screen cta",
        event_type: eventType,
      },
      "fantasy home",
    );
  };

  const handleLogin = () => {
    auth.signinRedirect({
      extraQueryParams: { language },
    });
    trackAuthClick("login", "login cta");
  };

  const handleRegister = () => {
    auth.signinRedirect({
      extraQueryParams: {
        action: "registration",
        language,
      },
    });
    trackAuthClick("register", "register cta");
  };

  if (auth.isAuthenticated && player) {
    return (
      <div className={loggedUserDiv}>
        <p className={loggedUserText}>
          <Trans
            ns="home"
            i18nKey="login.loggedInAs"
            values={{
              firstName: player.first_name,
              lastName: player.last_name,
            }}
          >
            You are logged in as <strong>{"{{ firstName }}"}</strong>{" "}
            <strong>{"{{ lastName }}"}</strong>
          </Trans>
        </p>
      </div>
    );
  }

  return (
    <Login>
      <div className={textContainerStyles}>
        <h2 className={desktopOnlyHeading}>
          {t("login.title", "Register to Play Fantasy Premier League")}
        </h2>
        <p className={textStyles}>
          <Trans ns="home" i18nKey="login.desc">
            With over 11 million players, Fantasy Premier League is the biggest
            Fantasy Football game in the world.
            <strong>It's FREE to play and you can win great prizes!</strong>
          </Trans>
        </p>
        <div className={buttonContainerStyles}>
          {/* LoginPromo styles extend base Button appearance to cater for fixed background */}
          <Button
            type="button"
            appearance="outlined"
            fullWidth={true}
            onPress={handleLogin}
            className={styles.loginButton}
          >
            {t("login.loginCta", "Log in")}
          </Button>
          <Button
            type="button"
            appearance="filled"
            fullWidth={true}
            onPress={handleRegister}
            className={styles.registerButton}
          >
            {t("login.registerCta", "Register now")}
          </Button>
        </div>
      </div>
      <img
        src={getPlayerComp().x1}
        srcSet={`${getPlayerComp().x1} 1x, ${getPlayerComp().x2} 2x`}
        alt={t("login.promoAlt", "Promo")}
        className={imageStyles}
      />
    </Login>
  );
};

export default LoginPromo;
